import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsEsPrioriClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async selectPrioridadePedido() {
    try {
      const { data } = await this.api.get('prioridade-pedido/infoPedido/selectPrioridadePedido');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Pedido Estab');
    }
  }
}
